import { NgModule } from "@angular/core";
import { InfoCardPanelComponent } from "./info-card-panel.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { InfoPanelVideoLightboxModule } from "./components/info-panel-video-lightbox/info-panel-video-lightbox.module";

@NgModule({
  declarations: [InfoCardPanelComponent],
  exports: [InfoCardPanelComponent],
  imports: [CommonModule, SharedModule, RouterModule, InfoPanelVideoLightboxModule],
})
export class InfoCardPanelModule {}
